<mat-card class="scrollable-card" [appearance]="appearance" [style.max-height]="cardMaxHeight">
	<ng-container *ngIf="messages.length > 0; else showEmptyMessage">
		<ng-container *ngFor="let message of messages">
			<div
				[ngClass]="{'error-content': getMessageType(message?.MessageType) === 'error', 'warning-content': getMessageType(message?.MessageType) === 'warning', 'info-content': getMessageType(message?.MessageType) === 'info'}">
				<div class="icon-container">
					<mat-icon>{{ getMessageType(message?.MessageType) }}</mat-icon>
				</div>
				<div class="message-container">
					{{ message?.Message }}
				</div>
			</div>
		</ng-container>
	</ng-container>
	<ng-template #showEmptyMessage>
		<div class="no-messages">No messages available.</div>
	</ng-template>
</mat-card>